import LeadGenerationContext from '../../context/LeadGenerationContext';

export const footerStyles = {
  footer: {
    background: '#F4F4F4 0% 0% no-repeat padding-box',
    opacity: 0.85,
    justifyContent: 'center',
    height: '38px',
    color: '#000000',
    alignItems: 'center',
    alignContent: 'center',
    display: 'flex',
  },

  copyrights_text: {
    textAlign: 'center',
    font: 'normal normal normal 12px/15px Arial',
    letterSpacing: '0.08px',
    color: '#000000',
    opacity: 1,
    fontWeight: 'bold',
  },
  bundle_footer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    width: '100%',
    bottom: 0,
    '@media (max-width:600px)': {
      paddingBottom: '0px',
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1300,
      paddingTop: '8px',
    },
  },
  footer_position: {
    position: 'absolute',
    width: '100%',
    bottom: 0,
  },
  libreBundle_text: {
    fontFamily: 'Arial',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '12px',
    lineHeight: 'normal',
    color: '#8A8A8A',
  },
};
